import { LoginContext } from '@shared/lib/models/login-context';
import { LoginTokens } from '@usana/ux/sso-auth';

export abstract class LoginContextProvider {
  public readonly isMobile: boolean;
  public readonly context: LoginContext;

  protected constructor(isMobile: boolean, context: LoginContext) {
    this.isMobile = isMobile;
    this.context = context;
  }

  abstract isProvided(window: Window): boolean;

  abstract notifyOfLogin(window: Window, tokens: LoginTokens, redirectUri: string);

  abstract handleExternalRedirect(window: Window, url: string): void;
}
